"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AppRouter = exports.entityRoutes = exports.AppRouterDefaultProps = void 0;
var react_1 = __importStar(require("react"));
var router_1 = require("@reach/router");
var lodash_1 = require("lodash");
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var auth0_react_1 = require("@auth0/auth0-react");
var private_route_1 = require("../elements/private-route");
var router_2 = require("@reach/router");
var use_app_sections_1 = require("../../hooks/use-app-sections");
var use_app_routes_1 = require("../../hooks/use-app-routes");
var use_active_user_1 = require("../../hooks/use-active-user");
var entity_form_route_1 = require("../entities/entity-form-route");
var entity_details_route_1 = require("../entities/entity-details-route");
var entity_list_route_1 = require("../entities/entity-list-route");
var content_1 = require("../elements/content");
var logout_route_1 = require("../pages/platform/logout-route");
var login_route_1 = require("../pages/platform/login-route");
var setup_terms_1 = require("../pages/setup/setup-terms");
var setup_change_password_1 = require("../pages/setup/setup-change-password");
var verify_change_password_1 = require("../pages/system/verify-change-password");
var entity_feed_route_1 = require("../entities/entity-feed-route");
var app_layout_1 = require("./app-layout");
var app_screen_layout_1 = require("./app-screen-layout");
var application_context_1 = require("../context/application-context");
var authorized_apollo_provider_1 = require("../context/authorized-apollo-provider");
var home_route_1 = require("../pages/platform/home-route");
var app_section_context_1 = require("../context/app-section-context");
var entity_definition_context_1 = require("../context/entity-definition-context");
exports.AppRouterDefaultProps = {
  include: {
    account: true
  }
};
var EntityRouteComponent = function (props) {
  var definition = props.definition,
    appSection = props.appSection;
  var Component = props.component;
  return react_1.default.createElement(entity_definition_context_1.EntityDefinitionProvider, {
    value: definition
  }, react_1.default.createElement(app_section_context_1.AppSectionProvider, {
    value: {
      appSection: appSection
    }
  }, react_1.default.createElement(Component, __assign({}, props))));
};
var AppSectionComponent = function (props) {
  var appSection = props.appSection,
    appSectionChild = props.appSectionChild;
  var Component = props.component;
  return react_1.default.createElement(app_section_context_1.AppSectionProvider, {
    value: {
      appSection: appSection,
      appSectionChild: appSectionChild
    }
  }, react_1.default.createElement(Component, __assign({}, props)));
};
var entityRoutes = function (definition, appSection) {
  // console.log("SETTING UP ROUTES", definition.name, appSection);
  var appSectionToUse = appSection || definition && definition.appSection;
  return (0, lodash_1.filter)([definition.routes.create && react_1.default.createElement(EntityRouteComponent, {
    appSection: appSectionToUse,
    definition: definition,
    path: definition.routes.create,
    component: (0, entity_form_route_1.entityCreateRouteComponent)(definition)
  }), definition.routes.update && react_1.default.createElement(EntityRouteComponent, {
    appSection: appSectionToUse,
    definition: definition,
    path: definition.routes.update,
    component: (0, entity_form_route_1.entityUpdateRouteComponent)(definition)
  }), definition.routes.list && react_1.default.createElement(EntityRouteComponent, {
    appSection: appSectionToUse,
    definition: definition,
    path: "".concat(definition.routes.list, "*"),
    component: (0, entity_list_route_1.entityListRouteComponent)(definition)
  }), definition.routes.listRedirect && react_1.default.createElement(EntityRouteComponent, {
    appSection: appSectionToUse,
    definition: definition,
    path: "".concat(definition.routes.listRedirect),
    component: (0, entity_list_route_1.entityListRouteComponent)(definition)
  }), definition.routes.details && react_1.default.createElement(EntityRouteComponent, {
    appSection: appSectionToUse,
    definition: definition,
    path: "".concat(definition.routes.details, "*"),
    component: entity_details_route_1.EntityDetailsRoute
  })]);
};
exports.entityRoutes = entityRoutes;
var ContentStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    padding: ", ";\n  "], ["\n    padding: ", ";\n  "])), theme_1.theme.UNIT(5))
});
var My = {
  Content: (0, styled_components_1.default)(content_1.Content)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["", ""], ["", ""])), ContentStyles)
};
var NotFound = function (props) {
  return react_1.default.createElement(app_screen_layout_1.AppScreenLayout, null, react_1.default.createElement(My.Content, null, react_1.default.createElement("h2", null, "Page not found"), react_1.default.createElement("p", null, "Sorry, this page doesn't exist in this website. You may have followed an invalid or outdated link."), react_1.default.createElement("p", null, react_1.default.createElement("a", {
    href: "/"
  }, "Return to the home page"))));
};
var onRedirectCallback = function (appState) {
  // Use router's navigate method to replace the url
  (0, router_2.navigate)((appState === null || appState === void 0 ? void 0 : appState.returnTo) || '/', {
    replace: true
  });
};
var AppRouter = function (props) {
  var include = props.include;
  var account = include.account;
  var applicationContext = (0, react_1.useContext)(application_context_1.ApplicationContext) || {
    entities: {},
    entityConfigs: {}
  };
  if (!applicationContext) {
    return null;
  }
  var entities = applicationContext.entities,
    entityConfigs = applicationContext.entityConfigs;
  var appSections = (0, use_app_sections_1.useAppSections)();
  // we don't want to include the platform path, as these are sub-routes of the application
  var publicRoutes = (0, use_app_routes_1.useAppRoutes)();
  var routes = (0, use_app_routes_1.useAppRoutes)();
  var includeEntities = (include === null || include === void 0 ? void 0 : include.entities) || (0, lodash_1.keys)(entities);
  var hasEntity = function (name) {
    return includeEntities.indexOf(name) !== -1;
  };
  /* Setup auto routes for configured entities */
  var entityRouteComponents = react_1.default.useMemo(function () {
    return (0, lodash_1.map)(entities, function (definition) {
      var appSection = definition.appSection;
      return hasEntity(definition.name) && (0, exports.entityRoutes)(definition, appSection);
    });
  }, [entities]);
  /* Setup routes for non-entity app sections */
  var appSectionRouteComponents = react_1.default.useMemo(function () {
    return (0, lodash_1.flatMap)(appSections, function (appSection) {
      return (appSection.children || []).map(function (child) {
        var path = "/".concat((0, lodash_1.filter)([appSection.path, child.path]).join('/'));
        if (child.type === 'component' && child.component) {
          return react_1.default.createElement(AppSectionComponent, {
            appSection: appSection,
            appSectionChild: child,
            key: "".concat(appSection.id).concat(child.id),
            component: child.component,
            path: path
          });
        }
        if (child.type === 'feed') {
          return react_1.default.createElement(AppSectionComponent, {
            appSection: appSection,
            appSectionChild: child,
            key: "".concat(appSection.id).concat(child.id),
            component: (0, entity_feed_route_1.entityFeedRouteComponent)(child.entities),
            path: path
          });
        }
      });
    });
  }, [appSections]);
  return react_1.default.createElement(auth0_react_1.Auth0Provider, {
    domain: process.env.AUTH0_DOMAIN,
    clientId: process.env.AUTH0_CLIENTID,
    scope: use_active_user_1.PERMISSIONS_SCOPES.join(' '),
    redirectUri: process.env.AUTH0_CALLBACK,
    audience: process.env.AUTH0_AUDIENCE,
    useRefreshTokens: true,
    cacheLocation: "localstorage",
    onRedirectCallback: onRedirectCallback
  }, react_1.default.createElement(authorized_apollo_provider_1.AuthorizedApolloProvider, null, react_1.default.createElement(router_1.Router, null, react_1.default.createElement(logout_route_1.LogoutRoute, {
    path: publicRoutes.logout
  }), react_1.default.createElement(setup_terms_1.SetupTermsPage, {
    path: publicRoutes.setupTerms
  }), react_1.default.createElement(setup_change_password_1.SetupChangePasswordPage, {
    path: publicRoutes.setupChangePassword
  }), react_1.default.createElement(verify_change_password_1.VerifyChangePasswordPage, {
    path: publicRoutes.verifyChangePassword
  }), react_1.default.createElement(private_route_1.PrivateRoute, {
    component: app_layout_1.AppLayout,
    path: "/"
  }, react_1.default.createElement(home_route_1.HomeRoute, {
    path: routes.home
  }), react_1.default.createElement(home_route_1.HomeRoute, {
    path: routes.homeReturn
  }), react_1.default.createElement(home_route_1.HomeRoute, {
    path: routes.network
  }), react_1.default.createElement(home_route_1.HomeRoute, {
    path: routes.following
  }), react_1.default.createElement(home_route_1.HomeRoute, {
    path: routes.wall
  }), react_1.default.createElement(home_route_1.HomeRoute, {
    path: routes.connections
  }), react_1.default.createElement(home_route_1.HomeRoute, {
    path: routes.conversations
  }), account && react_1.default.createElement(home_route_1.HomeRoute, {
    path: routes.profile
  }), react_1.default.createElement(login_route_1.LoginRoute, {
    path: routes.login
  }), react_1.default.createElement(NotFound, {
    default: true
  }), appSectionRouteComponents, entityRouteComponents))));
};
exports.AppRouter = AppRouter;
exports.AppRouter.defaultProps = exports.AppRouterDefaultProps;
var templateObject_1, templateObject_2;